import { Routes } from '@angular/router';
import { ShellComponent } from './shell/shell.component';
import { AdDetailsComponent } from './pages/ad-details/ad-details.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'register',
    loadComponent: () => import('./pages/register/register.component').then(m => m.RegisterComponent),
  },
  {
    path: '',
    component: ShellComponent,
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'anuncios/clientes',
        loadComponent: () => import('./pages/ads-clientes/ads-clientes.component').then(m => m.AdsClientesComponent)
      },
      {
        path: 'anuncios/barbearias',
        loadComponent: () => import('./pages/ads-barbearias/ads-barbearias.component').then(m => m.AdsBarbeariaComponent)
      },
      {
        path: 'anuncios/video',
        loadComponent: () => import('./pages/ads-video/ads-video.component').then(m => m.AdsVideoComponent)
      },
      {
        path: 'promover',
        loadComponent: () => import('./pages/promover-barbearia/promover-barbearia.component').then(m => m.PromoverBarbeariaComponent)
      },
      {
        path: 'relatorios',
        loadComponent: () => import('./pages/relatorios/relatorios.component').then(m => m.RelatoriosComponent)
      },
      {
        path: 'financeiro',
        loadComponent: () => import('./pages/financeiro/financeiro.component').then(m => m.FinanceiroComponent)
      },
      {
        path: 'configuracoes',
        loadComponent: () => import('./pages/configuracoes/configuracoes.component').then(m => m.ConfiguracoesComponent)
      },
      {
        path: 'home',
        loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent),
      },
      {
        path: 'ads/:id',
        component: AdDetailsComponent
      },
      {
        path: 'ads/:id/editar',
        loadComponent: () => import('./pages/edit-ad/edit-ad.component').then(m => m.EditAdComponent)
      },
      {
        path: 'checkout',
        loadComponent: () => import('./pages/checkout/checkout.component').then(m => m.CheckoutComponent)
      },
    ]
  },
  { path: '**', redirectTo: 'login' },
];
